import { Card, Flex, FlexGap, PageHeader } from '@pancakeswap/uikit'
import { useContext } from 'react'

import styled from 'styled-components'

import { SwapFeaturesContext } from './SwapFeaturesContext'
import { V3SwapForm } from './V3Swap'

import { StyledInputCurrencyWrapper } from './styles'

export enum Field {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
}

export const CardWidth = styled(Card)`
  border-radius: 24px;
  width: 100%;
  z-index: 1;
  background: none;
`

const SwapWrapper = styled(FlexGap)`
  margin-top: 0px;
`

const StyledContainer = styled(PageHeader)`
  max-width: 1250px !important;
`

export default function Swap() {
  const { isChartDisplayed } = useContext(SwapFeaturesContext)

  return (
    <>
      <StyledContainer background="none" pt={20} pb={50}>
        <SwapWrapper marginTop={0} flexWrap={['wrap', null, null, null, 'nowrap']} justifyContent="center">
          <Flex flexDirection="column" width="100%" maxWidth="580px">
            <StyledInputCurrencyWrapper marginLeft={['0px', '0px', isChartDisplayed ? '0px' : '0px']}>
              <V3SwapForm />
            </StyledInputCurrencyWrapper>
          </Flex>
        </SwapWrapper>
      </StyledContainer>
    </>
  )
}
